<template>

<dialog class="modalFrame" @click="onClick"><slot /></dialog>

</template>

<script setup>

const emit = defineEmits(['click']);
const onClick = (event) => emit('click', event);

</script>

<style lang="sass">

.modalFrame
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  height: 100%

  position: fixed
  left: 0
  top: 0
  z-index: 501

  border: 0
  background-color: #00000032

</style>
